import React from "react";
import { $Loading, $LoadingItem } from "./Loading.styles";

const Loading = () => (
  <$Loading>
    <$LoadingItem />
    <$LoadingItem />
    <$LoadingItem />
  </$Loading>
);

export default Loading;
